angular.module('services', [
    'services.dialogs',
    'services.authService',
    'services.helperService',
    'services.flexGridHelperService',
    'services.toasterService',
    'services.pricelistHelperService',
    'services.barcodeService',
    'services.mockImportFileRowService',
    'services.featureSwitchService',
    'services.translateHelper'
]);
